module.exports = __webpack_public_path__ + "img/vehicleLocation.d515e56d.svg";